import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HeaderComponent } from './header/header.component';
import { RouterModule } from '@angular/router';
import { WitnessAuthenticationComponent } from './witness-authentication/witness-authentication.component';
import { DialogModule } from 'primeng/dialog';
import { ButtonModule } from 'primeng/button';
import { FormsModule } from '@angular/forms';
import { LocationSelectComponent } from './location-select/location-select.component';
import { SelectModule } from 'primeng/select';
import { TableModule } from 'primeng/table';
import { ToastModule } from 'primeng/toast';
import { ServiceGrpSelectComponent } from './service-grp-select/service-grp-select.component';
import { UpdatePinComponent } from './update-pin/update-pin.component';
import { BrowseDocumentsComponent } from './browse-documents/browse-documents.component';
import { UploadDocumentComponent } from './upload-document/upload-document.component';
import { DataFilterPillsComponent } from './data-filter-pills/data-filter-pills.component';
import { NotificationComponent } from './notification/notification.component';
import { AnnouncementToastComponent } from './announcement-toast/announcement-toast.component';
import { ScrollPanelModule } from 'primeng/scrollpanel';
import {CardModule} from 'primeng/card';
import {MultiSelectModule} from 'primeng/multiselect';
import { CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA } from '@angular/core';
import { PopoverModule } from 'primeng/popover';
import {TooltipModule} from 'primeng/tooltip';
import { UnauthorizedComponent } from './unauthorized/unauthorized.component';
import { TreeSelectModule } from 'primeng/treeselect';
import { ToggleSwitchModule } from 'primeng/toggleswitch';
import { ResolutionCodeSelectComponent } from './resolution-code-select/resolution-code-select.component';
import { SidebarComponent } from './sidebar/sidebar.component';
import { MenuModule } from 'primeng/menu';
import { RefreshButtonComponent } from './refresh-button/refresh-button.component';
import { FormatQuantityPipe } from './pipes/format-quantity.pipe';
import { MentionEditorComponent } from './mention-editor/mention-editor.component';
// import { BrowserAnimationsModule } from '@angular/platform-browser/animations';


@NgModule({
  declarations: [HeaderComponent, SidebarComponent, WitnessAuthenticationComponent, LocationSelectComponent, ServiceGrpSelectComponent, UpdatePinComponent, BrowseDocumentsComponent, UploadDocumentComponent, DataFilterPillsComponent, NotificationComponent, AnnouncementToastComponent, UnauthorizedComponent, ResolutionCodeSelectComponent, RefreshButtonComponent, FormatQuantityPipe, MentionEditorComponent],
  imports: [
    RouterModule,
    TableModule,
    DialogModule,
    CommonModule,
    ButtonModule,
    FormsModule,
    SelectModule,
    ToastModule,
    ScrollPanelModule,
    CardModule,
    MultiSelectModule,
    PopoverModule,
    TooltipModule,
    TreeSelectModule,
    ToggleSwitchModule,
    MenuModule
    // BrowserAnimationsModule
  ],
  exports: [
    HeaderComponent
    , SidebarComponent
    , WitnessAuthenticationComponent
    , LocationSelectComponent
    , ServiceGrpSelectComponent
    , UpdatePinComponent
    , BrowseDocumentsComponent
    , UploadDocumentComponent
    , DataFilterPillsComponent
    , NotificationComponent
    , AnnouncementToastComponent
    , ResolutionCodeSelectComponent
    , LocationSelectComponent
    , RefreshButtonComponent
    , FormatQuantityPipe
    , MentionEditorComponent
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA,NO_ERRORS_SCHEMA]
})
export class SharedModule { }
